import apiClient from '@u/apiClient'
import RenameDossierAttachmentController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Attachment/RenameDossierAttachmentController'
import SoftDeleteDossierAttachmentController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Attachment/SoftDeleteDossierAttachmentController'
import UndoDeleteDossierAttachmentController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Attachment/UndoDeleteDossierAttachmentController'
import AddPictureToDossierGalleryController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Picture/AddPictureToDossierGalleryController'
import GetPicturesFromDossierGalleryController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Picture/GetPicturesFromDossierGalleryController'
import GetDossierScreenConfigController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierScreenConfigController'
import UpdateDossierScreenConfigController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierScreenConfigController'
import GetPictureFromDossierGalleryController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Picture/GetPictureFromDossierGalleryController'
import DeletePicturesFromDossierGalleryController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Picture/DeletePicturesFromDossierGalleryController'
import CopyPictureIntoAttachmentsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Picture/CopyPictureIntoAttachmentsController'
import AddPictureToDossierPictureController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Picture/AddPictureToDossierPictureController'
import UpdatePictureFromDossierGalleryController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Picture/UpdatePictureFromDossierGalleryController'

// const base_errors = { deceased: {}, events: [] }

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  async postDossierAttachments({ commit }, payload) {
    let formData = new FormData()

    formData.append('medias', JSON.stringify(payload.medias))

    await apiClient
      .post(`/api/dossier-attachment/${payload.dossier_id}`, payload)
      .then(async (response) => {
        commit('setDossier', response.data.dossier)
        // processSuccessCallback(payload)
      })
      .catch(async (reason) => {
        await console.error('postDossierAttachments', reason)
        throw reason
      })
  },
  // #region update

  async renameDossierAttachment({ commit }, payload) {
    await apiClient
      .route(
        RenameDossierAttachmentController.put({
          dossier: payload.dossier_id,
          media: payload.attachment_id
        }),
        { name: payload.new_name }
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setDossier', response.data.dossier)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error(reason)
      })
  },

  // #endregion

  // #region delete

  deleteDossierAttachment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SoftDeleteDossierAttachmentController.delete({
            dossier: payload.dossier_id,
            media: payload.attachment_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // #endregion

  // region undoDelete
  undoDossierAttachmentDelete({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UndoDeleteDossierAttachmentController.get({
            dossier: payload.dossier_id,
            media: payload.attachment_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  postPicturesToDossierGallery: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddPictureToDossierGalleryController.post({
            dossier: payload.dossier_id
          }),
          payload.form_data
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  fetchDossierGallery: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPicturesFromDossierGalleryController.get({
            dossier: payload.dossier_id
          }),
          {
            params: payload.params
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  fetchDossierScreenConfig: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDossierScreenConfigController.get({ dossier: payload.dossier_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateDossierScreenConfig: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierScreenConfigController.put({
            dossier: payload.dossier_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchMediaById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPictureFromDossierGalleryController.get({
            dossier: payload.dossier_id,
            picture_id: payload.media_id
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  deletePictureFromDossierGallery: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeletePicturesFromDossierGalleryController.delete({
            dossier: payload.dossier_id,
            picture_id: payload.picture_id
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  copyPictureIntoAttachment: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CopyPictureIntoAttachmentsController.post({
            dossier: payload.dossier_id,
            picture: payload.picture_id
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  usePictureGalleryForPictureDossier: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddPictureToDossierPictureController.post({
            dossier: payload.dossier_id,
            collection_name: 'picture'
          }),
          {
            media_id: payload.media_id
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  updateDossierPictureGallery: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .formRoute(
          UpdatePictureFromDossierGalleryController.put({
            dossier: payload.dossier_id,
            picture_id: payload.media_id
          }),
          payload.form_data
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  }
}
